module.exports = __webpack_public_path__ + "img/note-icon.5ba7defd.svg";